import { render } from "./commande.vue?vue&type=template&id=01c770cd&scoped=true"
import script from "./commande.vue?vue&type=script&lang=js"
export * from "./commande.vue?vue&type=script&lang=js"

import "./commande.vue?vue&type=style&index=0&id=01c770cd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01c770cd"]])

export default __exports__